// Switched out in production so that the build does not include the large list of event definitions
export default () => {};
